import axios from 'axios'
import { UpdateUserParams } from '../contexts/UserContext'
import { AddressProps } from '../types/user'
import { token } from './auth/auth'
import defaultOptions from './defaultoption'

const clientes = {
  async getLoggedUserPF() {
    return axios.get(
      `${process.env.REACT_APP_API_CLIENTES}clientes/pessoas-fisicas`,
      {
        headers: defaultOptions.headers
      }
    )
  },
  async updateUserPF(body: UpdateUserParams) {
    return axios.put(
      `${process.env.REACT_APP_API_CLIENTES}clientes/pessoas-fisicas`,
      body,
      {
        headers: defaultOptions.headers
      }
    )
  },
  async getLoggedUserPJ() {
    return axios.get(
      `${process.env.REACT_APP_API_CLIENTES}clientes/pessoas-juridicas`,
      {
        headers: {
          Authorization: `Bearer ${token()}`,
          'Content-Type': 'application/problem+json; charset=utf-8',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Max-Age': '86400'
        }
      }
    )
  },
  async getLoggedCompany(params) {
    return await fetch(
      `${process.env.REACT_APP_API_CLIENTES}clientes-pessoas-juridicas`,
      params
    )
  },
  async post(params) {
    return await fetch(
      `${process.env.REACT_APP_API_CLIENTES}clientes/pessoas-fisicas`,
      params
    )
  },
  async cargos() {
    return await fetch(`${process.env.REACT_APP_API_CLIENTES}cargos`, {
      method: 'GET',
      headers: defaultOptions.headers
    })
  },
  async departamentos() {
    return await fetch(`${process.env.REACT_APP_API_CLIENTES}departamentos`, {
      method: 'GET',
      headers: defaultOptions.headers
    })
  },
  async atividades() {
    return await fetch(`${process.env.REACT_APP_API_CLIENTES}atividades`, {
      method: 'GET',
      headers: defaultOptions.headers
    })
  },
  async subAtividades(idAtividade) {
    return await fetch(
      `${process.env.REACT_APP_API_CLIENTES}atividades/${idAtividade}/sub-atividades`
    )
  },
  async funcionarios() {
    return await fetch(`${process.env.REACT_APP_API_CLIENTES}funcionarios`, {
      method: 'GET',
      headers: defaultOptions.headers
    })
  },
  async enderecos(params) {
    return await fetch(
      `${process.env.REACT_APP_API_CLIENTES}clientes/enderecos`,
      params
    )
  },

  async getAddress() {
    return axios.get(
      `${process.env.REACT_APP_API_CLIENTES}clientes/enderecos`,
      {
        headers: defaultOptions.headers
      }
    )
  },

  async editAddress(address: AddressProps) {
    return axios.put(
      `${process.env.REACT_APP_API_CLIENTES}clientes/enderecos/${address.id}`,
      address,
      {
        headers: defaultOptions.headers
      }
    )
  },

  async getInscricaoEstadual(inscricaoEstadual, uf) {
    return await fetch(
      `${process.env.REACT_APP_API_CLIENTES}clientes/pessoas-juridicas/inscricao-estadual/${inscricaoEstadual}/${uf}`,
      {
        method: 'GET',
        headers: defaultOptions.headers
      }
    )
  },
  async getTokenParceria(token) {
    return await fetch(
      `${process.env.REACT_APP_API_CLIENTES}parcerias/token/${token}`,
      {
        method: 'GET',
        headers: defaultOptions.headers
      }
    )
  },
  async postTokenParceria(token) {
    return await fetch(
      `${process.env.REACT_APP_API_CLIENTES}parcerias/token/${token}`,
      {
        method: 'POST',
        headers: defaultOptions.headers
      }
    )
  },
  async postPromotorVendas() {
    return await fetch(`${process.env.REACT_APP_API_CLIENTES}promotor`, {
      method: 'POST',
      headers: defaultOptions.headers
    })
  },
  async getNews() {
    return await fetch(
      `${process.env.REACT_APP_API_CLIENTES}newsletter/receber`,
      {
        method: 'GET',
        headers: defaultOptions.headers
      }
    )
  },
  async patchNews(body) {
    return await fetch(
      `${process.env.REACT_APP_API_CLIENTES}newsletter/receber`,
      {
        method: 'PATCH',
        headers: defaultOptions.headers,
        body: JSON.stringify(body)
      }
    )
  },
  async validateEmail(email) {
    return await fetch(
      `${process.env.REACT_APP_API_CLIENTES}clientes/validar-email?email=${email}`,
      {
        method: 'GET',
        headers: defaultOptions.headers
      }
    )
  }
}

export default clientes
